import {writable} from 'svelte/store';

const {set, update, subscribe} = writable({
    visible: false,
    message: "",
});

let tm = null;

const success = {
    set, update, subscribe, show: msg => {
        clearTimeout(tm);
        update(state => {
            state.visible = true;
            state.message += '<p>' + msg + '</p>';
            return state;
        });
        tm = setTimeout(function () {
            update(state => {
                state.visible = false;
                return state;
            });
            setTimeout(function () {
                update(state => {
                    state.message = "";
                    return state;
                });
            }, 300);

        }, 3000);
    }
}
export default success;